var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-select-field',{attrs:{"items":_vm.availableMetrics,"label":_vm.label || _vm.$t('kpi.metrics.parameter'),"name":_vm.name,"required":_vm.required,"hide-details":_vm.hideDetails},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }